import { FormattedMessage, useIntl } from "react-intl";

type Country = "CA" | "US" | "OTHER";

interface CountryOption {
  value: Country;
  labelId: string;
  defaultLabel: string;
  descriptionId: string;
  defaultDescription: string;
  flag: string;
}

const COUNTRY_OPTIONS: CountryOption[] = [
  {
    value: "CA",
    labelId: "auth.register.country.CA",
    defaultLabel: "Canada",
    descriptionId: "auth.register.country.CA.description",
    defaultDescription: "Canadian organization with local document categories",
    flag: "\u{1F1E8}\u{1F1E6}",
  },
  {
    value: "US",
    labelId: "auth.register.country.US",
    defaultLabel: "United States",
    descriptionId: "auth.register.country.US.description",
    defaultDescription:
      "United States organization with local document categories",
    flag: "\u{1F1FA}\u{1F1F8}",
  },
  {
    value: "OTHER",
    labelId: "auth.register.country.OTHER",
    defaultLabel: "Other",
    descriptionId: "auth.register.country.OTHER.description",
    defaultDescription: "International organization",
    flag: "\u{1F30D}",
  },
];

interface LocationSelectorProps {
  country: Country;
  onCountryChange: (country: Country) => void;
}

export const LocationSelector = ({
  country,
  onCountryChange,
}: LocationSelectorProps) => {
  const intl = useIntl();
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-2 p-1">
        {COUNTRY_OPTIONS.map((option) => (
          <div
            key={option.value}
            role="button"
            tabIndex={0}
            aria-pressed={country === option.value}
            aria-label={intl.formatMessage({
              id: option.labelId,
              defaultMessage: option.defaultLabel,
            })}
            onClick={() => onCountryChange(option.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onCountryChange(option.value);
              }
            }}
            className={`
              relative flex cursor-pointer rounded-lg border p-3 sm:p-4 transition-all focus:ring-2 focus:ring-[#60A5FA] focus:outline-none
              ${
                country === option.value
                  ? "border-[#60A5FA] ring-1 ring-[#60A5FA] bg-sky-50 dark:bg-sky-950"
                  : "border-border hover:border-border/80 hover:bg-accent bg-background"
              }
            `}
          >
            <div className="flex flex-1 gap-3 sm:gap-4 items-center">
              <span className="text-2xl">{option.flag}</span>
              <div className="flex flex-col flex-1 min-w-0">
                <span className="block text-sm font-[500] text-foreground">
                  <FormattedMessage
                    id={option.labelId}
                    defaultMessage={option.defaultLabel}
                  />
                </span>
                <span className="mt-1 sm:mt-[6px] text-xs text-muted-foreground">
                  <FormattedMessage
                    id={option.descriptionId}
                    defaultMessage={option.defaultDescription}
                  />
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
